import React from "react";
import OddsBtn from "@/components/oddsBtn";
import { Maybe, OddsSelection, Scalars } from "@/graphql/gql/graphql";
import Styles from "./Selection.module.scss";

export type SelectionProps = {
  oddsValue?: Maybe<Scalars["String"]>;
  onOddsClick: () => void;
} & OddsSelection;

const Selection = ({
  oddsValue,
  runnerName,
  onOddsClick,
  handicap,
  player,
}: SelectionProps) =>
  oddsValue ? (
    <div className={Styles.cardContainer}>
      {player?.playerSportsbookUrl ? (
        <a
          href={player.playerSportsbookUrl}
          className={Styles.selectionName}
          target="_blank"
          rel="noreferrer noopener"
        >
          {runnerName}
        </a>
      ) : (
        <span className={Styles.selectionName}>{runnerName}</span>
      )}
      <OddsBtn
        classButton={Styles.oddsBtn}
        classHandicap={Styles.handicap}
        onClick={onOddsClick}
        odds={oddsValue}
        handicap={handicap}
      />
    </div>
  ) : (
    <React.Fragment />
  );

export default Selection;
